"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAppStageName = exports.getStageInfo = exports.isProdSpectrometer = exports.isProd = exports.isDev = void 0;
const STAGES_PROD = ['prod', 'prod.test'];
const STAGES_GAMMA = ['gamma', 'gamma.test'];
const STAGES_BETA = ['beta', 'beta.test'];
const STAGES_ALPHA = ['alpha', 'alpha.test'];
const STAGES_DEV = ['dev', 'dev.test'];
exports.isDev = (config) => STAGES_DEV.includes(config.stage);
exports.isProd = (config) => STAGES_PROD.includes(config.stage);
/*
  We intentionally send all non-dev metrics to the spectrometer prod dataset. This allows us to review all
  spectrometer metrics on https://spectrometer.corp.amazon.com/
  The AppStageName value is still unique, and cleanly namespaces the data in PMET/Andes/Spectrometer
*/
exports.isProdSpectrometer = (config) => [...STAGES_PROD, ...STAGES_GAMMA, ...STAGES_BETA, ...STAGES_ALPHA].includes(config.stage);
exports.getStageInfo = (config) => (exports.isDev(config) && config.user ? `${config.stage}.${config.user}` : config.stage);
exports.getAppStageName = (config) => `${config.app}.${exports.getStageInfo(config)}`;
